export const computeUrl = (baseUrl, href) => {
  if (href.startsWith('http')) {
    return href;
  }
  return `${baseUrl}${href}`;
};
